import React, { useEffect, useState, useMemo } from "react";
import { COLUMNS } from './columns'
import Table from "../../common/Table/Table";
import AddUserButton from "../../common/AddUserButton/AddUserButton";
import Modal from "../../common/Modal/Modal";
import GroceriesForm from "../../forms/GroceriesForm/GroceriesForm";
import { PencilIcon, TrashIcon } from '@heroicons/react/outline';
import GroceriesService from "../../../services/GroceriesService";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

const Groceries = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [shouldLoad, setShouldLoad] = useState(true)
    const [groceryData, setGroceryData] = useState({})
    const [modalTitle, setModalTitle] = useState('')
    const [buttonText, setButtonText] = useState('Dodaj Namirnicu')
    const [groceriesData, setGroceriesData] = useState(null)

    useEffect(() => {
        if (shouldLoad) {
            setShouldLoad(false)
            getGroceries()
        }
    }, [shouldLoad])

    const getGroceries = () => {
        GroceriesService.getSGroceriesUrl().then((response) => {
            setGroceriesData(response.data)
        });
    };

    const deleteGrocery = (id) => {
        MySwal.fire({
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
            denyButtonText: `Obriši`,
            cancelButtonText: `Otkaži`,
        }).then((result) => {
            if (result.isDenied) {
                GroceriesService.deleteGrocery(id).then(() => {
                    setShouldLoad(true)
                });
            }
        })

    };

    const addGrocery = (data, formValues) => {
        if (Object.keys(data).length === 0) {
            GroceriesService.addGrocery(formValues).then(() => {
                setShouldLoad(true)
            });
        } else {
            GroceriesService.updateGrocery(formValues).then(() => {
                setShouldLoad(true)
            });
        }
    }

    const openModal = (row) => {
        setGroceryData(row.original);
        setIsOpen(true);
        setModalTitle('Izmeni namirnicu');
    };

    const additionalColumn = {
        Header: ' ',
        Cell: ({ row }) => (
            <div className="flex items-center justify-end">
                <span className="p-2 rounded-full transition cursor-pointer purpleGradient" title="Obriši" onClick={() => deleteGrocery(row.original.id)}><TrashIcon className="w-4 h-4 text-white transition" /></span>
            </div>
        )
    }
    return (
        <>
            <AddUserButton setIsOpen={setIsOpen} setUserData={setGroceryData} setModalTitle={setModalTitle} buttonText={buttonText} />
            {isOpen &&
                <Modal setIsOpen={setIsOpen} modalContent={<GroceriesForm groceryData={groceryData} modalTitle={modalTitle} groceriesData={groceriesData} setGroceriesData={setGroceriesData} setIsOpen={setIsOpen} addGrocery={addGrocery} />} />
            }
            {groceriesData !== null ?
                <Table openModal={openModal} columnsProp={COLUMNS} dataProp={groceriesData} additionalColumn={additionalColumn} setIsOpen={setIsOpen} setGroceriesData={setGroceriesData} setModalTitle={setModalTitle} />
                : null}
        </>
    )

};

export default Groceries;
